import React from 'react';
import _ from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface WaiverTextFieldProps {
  label?: string;
  placeholder?: string;
  value: string;
  required?: boolean;
  large?: boolean;
  condition?: boolean;
  onChange: any;
  tooltip?: boolean;
  tooltipTitle?: string;
  errorTooltip?: boolean;
  onClick?: () => void;
  className?: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}
const WaiverTextField: React.FC<WaiverTextFieldProps> = ({
  label,
  placeholder,
  value,
  required,
  large,
  condition,
  onChange,
  tooltip,
  tooltipTitle,
  errorTooltip,
  onClick = () => {},
  className = '',
  onBlur = (e) => {}
}) => {

  const showField = (): boolean => (_.isBoolean(condition) ? condition : true);
  const showTooltip = (): boolean => !!tooltip;
  const fullLabel = label + (required ? '*' : '');
  const wrapperClass = large ? 'text-area' : '';
  const inputId = Math.random().toString(16).slice(2);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    onChange(e.target.value);
  };

  return <>
    {showField() && (
      <div className={`form-group ${wrapperClass}`}>
        <label htmlFor={"waiverDescriptionInput"}>{fullLabel}:</label>
        {large ? (
          <textarea
            className="form-control"
            id={inputId}
            placeholder={placeholder}
            value={value}
            required={required}
            onChange={handleChange}
          />
        ) : (
          <OverlayTrigger delay={{ hide: 450, show: 300 }} show={errorTooltip} placement="bottom"
            overlay={(props) => (
              <>
                <Tooltip {...props} bsPrefix='waiver-error-tooltip popover textfield-error-tooltip'>
                  <div className="popover-inner">
                    <div className="popover-content">
                      <span className="sprites sprite-details-selected-24"></span>Please fill this field.
                    </div>
                  </div>
                </Tooltip>
              </>
            )}><input
              type="text"
              className={`form-control ${className}`}
              id={inputId}
              placeholder={placeholder}
              value={value}
              required={required}
              onChange={handleChange}
              onClick={onClick}
              onBlur={onBlur}
            /></OverlayTrigger>
        )}
        {showTooltip() && (
          <OverlayTrigger delay={{ hide: 450, show: 300 }} placement="top"
            overlay={(props) => (
              <>
                <Tooltip {...props} bsPrefix='waiver-tooltip popover'>
                  <div className="popover-inner">
                    <h3 className="popover-title">Suggestions</h3>
                    <div className="popover-content">
                      If supported ticket stocks are not specified, apply 057.
                      Multiple ticket stocks may be specified.
                    </div>
                  </div>
                </Tooltip>
              </>
            )}>
            <div className="popover-icon sprites sprite-details-normal-24 margin-left-5"></div>
          </OverlayTrigger>
        )}
      </div>
    )}
  </>;
};

export default WaiverTextField;